export class FilterModal {
	/**
	 * Init the class
	 *
	 * @param {HTMLElement} rootEl The root element of the block
     * @param {string} rootEl The class to add to the body when active
	 */
	constructor(rootEl, controlClass) {

        const self = this;
        this.filterBtns = rootEl.querySelectorAll('.filter-mobile-button'); 
        this.closeBtns = rootEl.querySelectorAll('.close-filter-menu'); 
        this.controlClass = controlClass;
        this.bodyClass = 'filter-menu-open';

        this.filterBtns.forEach((btn) => {
			btn.addEventListener('click', function () {
				self.openFilterMenu(this);
			});
		});

        this.closeBtns.forEach((btn) => {
			btn.addEventListener('click', function () {
				self.closeFilterMenu(this);
			});
		});

	}

    /*
	 * Opens filter menu
	 * @return    {void}
	 */
    openFilterMenu() {
        document.body.classList.add(this.controlClass);
        document.body.classList.add(this.bodyClass);
    }

    /*
	 * Close filter menu
	 * @return    {void}
	 */
    closeFilterMenu() {
        document.body.classList.remove(this.controlClass);
        document.body.classList.remove(this.bodyClass);
    }
}
